export default __webpack_public_path__ + "static/media/nothing_added.372acc79.svg";